// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1swqT","sigContainer":"styles_sigContainer__78M6-","sigPad":"styles_sigPad__PMUVu","sigImage":"styles_sigImage__1-hAd"};